/** @format */

import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { CommonModule } from '@angular/common';
import { HomrGTGTContent } from '@shared/data-access/interfaces';

@Component({
	selector: 'pdp-gtgt-content',
	templateUrl: './gtgt-content.component.html',
	styleUrl: './gtgt-content.component.scss',
	imports: [CommonModule],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class GtgtContentComponent {
	readonly gtgtContent = input<HomrGTGTContent>();

	/**
	 * @description
	 * Text color
	 */
	readonly textColor = computed(() =>
		typeof this.gtgtContent()?.foregroundColor === 'string' &&
		this.gtgtContent().foregroundColor.trim() !== ''
			? this.gtgtContent().foregroundColor
			: '#910208'
	);

	readonly displayLink = computed(() =>
		this.gtgtContent() !== undefined
			? this.gtgtContent().linkTitle?.length > 0 && this.gtgtContent().link?.length > 0
			: false
	);
}
